import { createContext } from "react";

const Context = createContext({ state: {}, actions: {} });
export default Context;
